import CustomButton from "components/common/Button";
import Dialog, { DialogTitle, DialogContent } from "components/common/Dialog";

import EdgeLogo from "assets/images/logo_edge.svg";
import ReferBusinessGraphic from "assets/images/customerReferralHeader.svg";
import LinkedInIcon from "assets/images/linkedin_share.svg";
import FacebookIcon from "assets/images/fb_share.svg";
import InstagramIcon from "assets/images/instagram.svg";
import XIcon from "assets/images/x_share.svg";
import ThreadsIcon from "assets/images/threads.svg";
import TikTokIcon from "assets/images/tiktok.svg";
import YouTubeIcon from "assets/images/youtube.svg";

import "./EmailPreviewModal.scss";

interface EmailPreviewModalProps {
  open: boolean;
  onClose: () => void;
}

function EmailPreviewModal({ open, onClose }: EmailPreviewModalProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      size="md"
      width={652}
      title={<DialogTitle title="Email preview" showCloseIcon onClose={onClose} />}
      content={
        <DialogContent>
          <div className="email-preview-content">
            <div className="email-logo-section">
              <img src={EdgeLogo} alt="Edge" style={{ height: "19px", width: "81.241px" }} />
            </div>

            <div className="email-body-section">
              <div className="email-hero-banner">
                <div className="hero-text">
                  <p>Your invitation</p>
                  <p>to try Edge</p>
                </div>
                <img src={ReferBusinessGraphic} alt="" className="hero-image" />
              </div>

              <div className="email-content">
                <div className="email-text-section">
                  <h2 className="email-title">Mark invited you to try Edge</h2>
                  <div className="email-body-text">
                    <p>
                      Edge helps businesses build reliable remote teams with ease. Our professionals are trained,
                      verified, and ready to step in — helping you scale faster while keeping overhead low.
                    </p>
                    <p>&nbsp;</p>
                    <p>
                      Join 1,000+ businesses that trust Edge to provide skilled, compliant remote talent across
                      healthcare, dental, and insurance industries.
                    </p>
                  </div>
                </div>

                <CustomButton
                  label="Explore Edge"
                  variant="contained"
                  color="primary"
                  size="large"
                  onClick={() => {}}
                />
              </div>

              <p className="email-signature">Team Edge</p>
            </div>

            <div className="email-footer-section">
              <hr className="footer-divider-top" />
              <div className="social-icons">
                <img src={LinkedInIcon} alt="LinkedIn" />
                <img src={FacebookIcon} alt="Facebook" />
                <img src={InstagramIcon} alt="Instagram" />
                <img src={XIcon} alt="X" />
                <img src={ThreadsIcon} alt="Threads" />
                <img src={TikTokIcon} alt="TikTok" />
                <img src={YouTubeIcon} alt="YouTube" />
              </div>
              <hr className="footer-divider-bottom" />
              <p className="footer-disclaimer">This is a system-generated email. Please do not reply.</p>
            </div>
          </div>
        </DialogContent>
      }
    />
  );
}

export default EmailPreviewModal;
